module.exports = __webpack_public_path__ + "static/media/other-movers.db4eb109.jpg";